module.exports = __webpack_public_path__ + "img/jarom-v2.26d55f0.jpg";